import { render, staticRenderFns } from "./Ingress.vue?vue&type=template&id=0439d492&scoped=true&"
import script from "./Ingress.vue?vue&type=script&lang=js&"
export * from "./Ingress.vue?vue&type=script&lang=js&"
import style0 from "./Ingress.vue?vue&type=style&index=0&id=0439d492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0439d492",
  null
  
)

export default component.exports